import { useGetDarkMode }      from "_common/hooks/global";
import { useGetUpdateSession } from "_jotai/liveSession";

import RecommendedSessions from "./RecommendedSessions";

const component = ( { sessions, broadcastId, isMobile } ) => {
	const darkMode = useGetDarkMode ();
	const data     = useGetUpdateSession ();

	return (
		<div style = { { display: "flex" } }>
			<RecommendedSessions
				broadcastId = { broadcastId }
				darkMode    = { darkMode }
				isMobile    = { isMobile }
				sessions    = { sessions }
				showAds     = { data?.showAds ?? true }
			/>
		</div>
	);
};

export default component;
